export default "__VITE_ASSET__DbaKXTqE__"